import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

import "../App.css";

function Header() {
  const { user, logout, updateUser } = useUser();
  const navigate = useNavigate();

  const handleSignOut = () => {
    logout();
    navigate("/");
  };

  const handleChangeNetId = () => {
    // Set the isNetIdSubmitted flag to false in the parent component
    // This will cause the NetIdInput component to be rendered
    updateUser({ ...user, net_id: null });
    navigate("/assessments");
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-title-section">
          <h1>CS411 - Database Systems</h1>
          <p className="app-subtitle">
            AI-powered feedback for SQL assessments
          </p>
        </div>

        {user && (
          <div className="user-profile">
            <div className="user-info">
              <img src={user.picture} alt={user.name} className="user-avatar" />
              <div className="user-details">
                <span className="user-name">{user.name}</span>
                {user.net_id && (
                  <div className="user-netid-container">
                    <span
                      className="user-netid clickable-netid"
                      onClick={handleChangeNetId}
                    >
                      NetID: {user.net_id}
                    </span>
                  </div>
                )}
              </div>
              <button className="sign-out-button" onClick={handleSignOut}>
                Sign Out
              </button>
            </div>
          </div>
        )}
      </div>

      {user && (
        <nav className="app-nav">
          <Link to="/assessments" className="nav-link">
            Assessments
          </Link>
          
          <Link to="/courses" className="nav-link">
            {user.role === 'instructor' ? 'Manage Courses' : 'My Classes'}
          </Link>
          
          {/* Only show Teacher Dashboard to instructors */}
          {user.role === 'instructor' && (
            <Link to="/teacher" className="nav-link">
              Teacher Dashboard
            </Link>
          )}
          {/* Learning Analytics (instructors only) */}
          {user.role === 'instructor' && (
            <Link to="/learning-analytics" className="nav-link">
              Learning Analytics
            </Link>
          )}
          <Link to="/knowledge-graph" className="nav-link">
            Knowledge Graph
          </Link>
          <Link to="/chat-with-kg" className="nav-link">
          Chat with KG
        </Link>

          
          {/* Show role indicator */}
          <span className="role-indicator">
            {user.role === 'instructor' ? 'Instructor' : 'Student'}
          </span>
        </nav>
      )}
    </header>
  );
}

export default Header;
